import React from 'react';
import LoadingFade from "../../common/LoadingFade";

const SingleImageSkeleton = () => (
  <LoadingFade loading={true}/>
);

export default SingleImageSkeleton;
